var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "auto-height",
        { staticClass: "p-2 d-flex flex-column", attrs: { margin: 10 } },
        [
          _c(
            "div",
            { staticClass: "d-flex list-header mb-2" },
            [
              _c("input-debounced", {
                staticClass: "search-bar",
                attrs: {
                  clearable: true,
                  autofocus: true,
                  placeholder: "Search",
                },
                model: {
                  value: _vm.search,
                  callback: function ($$v) {
                    _vm.search = $$v
                  },
                  expression: "search",
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-purple ml-1",
                    on: { click: _vm.refreshList },
                  },
                  [
                    _c("i", {
                      staticClass: "fas fa-sync",
                      class: { "fa-spin": _vm.isListRefreshingActive },
                    }),
                  ]
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("contact-list", {
            ref: "list",
            staticClass: "list overflow-auto",
            attrs: { url: _vm.urlWithFilters },
            on: {
              "refresh-start": _vm.onListRefreshStarted,
              "refresh-finish": _vm.onListRefreshFinished,
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "contact-list-item",
                      _vm._b(
                        {
                          staticClass: "mb-2 d-flex item",
                          on: { edit: _vm.onEdit },
                        },
                        "contact-list-item",
                        scope,
                        false
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }